import React from 'react';

/* packages */
import DesignSection from '../../util-mui-design-section';
/* packages */

const Index = props => {
  return <DesignSection.Title>
    Company Decline
  </DesignSection.Title>
}

export default Index;
